/* ============================================================
   Bedenini Bul (Kids) — Fahhar Kids / Prestige teması
   Kendi kendine yeten beden önerici. Tema JS'ine bağımlı değildir;
   tetikleyici [data-fmk-open], veri [data-fmk-config] üzerinden gelir.
   Akış: Yaş -> Boy -> Kilo -> Sonuç (yaş bedeni). Figür yok; sadece bilgi girişi.
   ============================================================ */
(function () {
  "use strict";

  var overlay = null;
  var config = null;
  var state = {};
  var touched = {};
  var stepIndex = 0;
  var completed = false;
  var started = false;

  /* Yaş bedeni <-> boy aralığı (TR/EU konfeksiyon standardı, cm) */
  var SIZES = [
    { code: "1-2 Yaş", h: [80, 92] },
    { code: "2-3 Yaş", h: [92, 98] },
    { code: "3-4 Yaş", h: [98, 104] },
    { code: "4-5 Yaş", h: [104, 110] },
    { code: "5-6 Yaş", h: [110, 116] },
    { code: "6-7 Yaş", h: [116, 122] },
    { code: "7-8 Yaş", h: [122, 128] }
  ];

  /* Yaşa göre ortalama boy (slider varsayılanı için) */
  var AGE_HEIGHT = { 1: 80, 2: 88, 3: 96, 4: 103, 5: 110, 6: 116, 7: 122, 8: 128 };

  function typicalWeight(h) {
    var t = 0.5 * h - 36; /* 92cm->10kg, 110->19, 128->28 */
    return t < 8 ? 8 : t;
  }

  var STEPS = [
    { key: "age", label: "Yaş", unit: "yaş", min: 1, max: 8, def: 4, hint: "Bitirdiği yaşı seç." },
    { key: "height", label: "Boy", unit: "cm", min: 75, max: 135, def: 103, hint: "Beden için en belirleyici ölçü boydur." },
    { key: "weight", label: "Kilo", unit: "kg", min: 8, max: 45, def: 16, hint: "Yaklaşık değer yeterli." }
  ];

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---------------- beden hesaplama ---------------- */
  function recommend(age, height, weight) {
    var idx = -1, clamped = null;
    if (height < SIZES[0].h[0]) { idx = 0; clamped = "under"; }
    else {
      for (var i = 0; i < SIZES.length; i++) {
        if (height <= SIZES[i].h[1]) { idx = i; break; }
      }
      if (idx === -1) { idx = SIZES.length - 1; clamped = "over"; }
    }
    var heightIdx = idx;

    /* Kilo boyuna göre belirgin yüksekse bir üst beden (dar gelmesin) */
    var bumped = false;
    var ratio = weight / typicalWeight(height);
    if (ratio >= 1.22 && idx < SIZES.length - 1 && !clamped) { idx++; bumped = true; }

    /* Yaşın işaret ettiği beden (not için) */
    var ageIdx = Math.min(Math.max(Math.round(age) - 1, 0), SIZES.length - 1);

    var confidence = clamped ? "out" : (bumped || Math.abs(ageIdx - heightIdx) >= 2) ? "medium" : "high";
    return {
      row: SIZES[idx],
      heightRow: SIZES[heightIdx],
      ageRow: SIZES[ageIdx],
      bumped: bumped,
      slim: ratio <= 0.8,
      clamped: clamped,
      confidence: confidence
    };
  }

  /* ---------------- overlay iskeleti ---------------- */
  function buildOverlay() {
    overlay = document.createElement("div");
    overlay.className = "fmk-overlay";
    overlay.innerHTML =
      '<div class="fmk-sheet" role="dialog" aria-modal="true" aria-label="Bedenini Bul">' +
      '  <div class="fmk-header">' +
      '    <span class="fmk-eyebrow" data-fmk-eyebrow>BEDENİNİ BUL</span>' +
      '    <button type="button" class="fmk-close" data-fmk-close aria-label="Kapat">&times;</button>' +
      "  </div>" +
      '  <div class="fmk-progress" data-fmk-progress></div>' +
      '  <div class="fmk-controls" data-fmk-controls></div>' +
      "</div>";
    document.body.appendChild(overlay);

    var progress = overlay.querySelector("[data-fmk-progress]");
    STEPS.forEach(function () {
      progress.insertAdjacentHTML("beforeend", '<div class="fmk-progress__dot"><i></i></div>');
    });

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeQuiz();
    });
    overlay.querySelector("[data-fmk-close]").addEventListener("click", closeQuiz);
  }

  function resetState() {
    state = {};
    touched = {};
    STEPS.forEach(function (s) { if (s.def != null) state[s.key] = s.def; });
    stepIndex = 0;
    completed = false;
  }

  function renderProgress() {
    var dots = overlay.querySelectorAll(".fmk-progress__dot i");
    dots.forEach(function (dot, i) {
      dot.style.width = i < stepIndex ? "100%" : i === stepIndex ? "50%" : "0%";
    });
  }

  function clearResult() {
    var r = overlay.querySelector(".fmk-result");
    if (r) r.remove();
  }

  function sliderFill(slider) {
    var pct = (slider.value - slider.min) / (slider.max - slider.min) * 100;
    slider.style.background = "linear-gradient(to right, #211d18 " + pct + "%, #e3ddd2 " + pct + "%)";
  }

  /* ---------------- adımlar ---------------- */
  function renderStep() {
    clearResult();
    overlay.querySelector("[data-fmk-progress]").style.display = "";
    overlay.querySelector("[data-fmk-eyebrow]").textContent =
      "BEDENİNİ BUL · ADIM " + (stepIndex + 1) + "/" + STEPS.length;
    renderProgress();

    var s = STEPS[stepIndex];
    var controls = overlay.querySelector("[data-fmk-controls]");

    /* Slider adımları */
    if (s.key === "height" && !touched.height) state.height = AGE_HEIGHT[Math.round(state.age)] || 103;
    if (s.key === "weight" && !touched.weight) state.weight = Math.round(typicalWeight(state.height));


    /* Kompakt tek hiza: başlık + (−) slider (+) + değer kutusu aynı satırda */
    controls.innerHTML =
      '<div class="fmk-ctl-line">' +
      '  <div class="fmk-ctl-title">' + s.label + "</div>" +
      '  <button type="button" class="fmk-stepper" data-fmk-dec aria-label="Azalt">−</button>' +
      '  <div class="fmk-slider-col">' +
      '    <input type="range" class="fmk-range" data-fmk-slider min="' + s.min + '" max="' + s.max + '" step="1" value="' + state[s.key] + '">' +
      "  </div>" +
      '  <button type="button" class="fmk-stepper" data-fmk-inc aria-label="Artır">+</button>' +
      '  <div class="fmk-ctl-pill" data-fmk-readout>' + state[s.key] + "<small>" + s.unit + "</small></div>" +
      "</div>" +
      '<div class="fmk-ctl-hint">' + s.hint + "</div>" +
      '<div class="fmk-buttons">' +
      '<button type="button" class="fmk-btn-back' + (stepIndex === 0 ? " is-hidden" : "") + '" data-fmk-back>‹ Geri</button>' +
      '<button type="button" class="fmk-btn-next" data-fmk-next>' + (stepIndex === STEPS.length - 1 ? "Sonucu Gör" : "İleri") + "</button>" +
      "</div>" +
      (stepIndex === 0 ? '<div class="fmk-privacy">Bilgiler cihazında kalır; kaydedilmez, paylaşılmaz.</div>' : "");

    var slider = controls.querySelector("[data-fmk-slider]");
    var readout = controls.querySelector("[data-fmk-readout]");
    sliderFill(slider);

    function setValue(v) {
      v = Math.max(s.min, Math.min(s.max, v));
      state[s.key] = v;
      touched[s.key] = true;
      slider.value = v;
      readout.innerHTML = v + "<small>" + s.unit + "</small>";
      sliderFill(slider);
      if (s.key === "age" && !touched.height) state.height = AGE_HEIGHT[v] || 103;
      if (!touched.weight && (s.key === "age" || s.key === "height")) state.weight = Math.round(typicalWeight(state.height));
    }
    slider.addEventListener("input", function () { setValue(Number(slider.value)); });
    controls.querySelector("[data-fmk-dec]").addEventListener("click", function () { setValue(state[s.key] - 1); });
    controls.querySelector("[data-fmk-inc]").addEventListener("click", function () { setValue(state[s.key] + 1); });
    controls.querySelector("[data-fmk-back]").addEventListener("click", function () {
      if (stepIndex > 0) { stepIndex--; renderStep(); }
    });
    controls.querySelector("[data-fmk-next]").addEventListener("click", function () {
      if (stepIndex < STEPS.length - 1) { stepIndex++; renderStep(); }
      else renderResult();
    });
  }

  /* ---------------- varyant eşleştirme (Prestige) ---------------- */
  function parseAgeRange(str) {
    var m = String(str).match(/(\d{1,2})\s*[-–]\s*(\d{1,2})/);
    if (m) return [Number(m[1]), Number(m[2])];
    /* tekli yaş bedeni: "3 Yaş" ya da "3" -> [3,3] */
    m = String(str).match(/(\d{1,2})/);
    if (m) {
      var n = Number(m[1]);
      if (n >= 1 && n <= 14) return [n, n];
    }
    return null;
  }

  function matchVariantValue(row) {
    var values = (config && config.sizeValues) || [];
    var i, v;
    if (values.length === 1) return String(values[0]);
    /* 1) birebir metin */
    for (i = 0; i < values.length; i++) {
      v = String(values[i]);
      if (v.replace(/\s+/g, " ").trim().toLowerCase() === row.code.toLowerCase()) return v;
    }
    /* 2) yaş aralığı örtüşmesi (örn. "1-4 Yaş" geniş aralığı) */
    var rowRange = parseAgeRange(row.code);
    if (!rowRange) return null;
    var rowMid = (rowRange[0] + rowRange[1]) / 2;
    var best = null, bestOverlap = -1, bestDist = Infinity, bestMid = -1;
    for (i = 0; i < values.length; i++) {
      v = String(values[i]);
      var r = parseAgeRange(v);
      if (!r) continue;
      var overlap = Math.min(r[1], rowRange[1]) - Math.max(r[0], rowRange[0]);
      var mid = (r[0] + r[1]) / 2;
      var dist = Math.abs(mid - rowMid);
      var better =
        overlap > bestOverlap ||
        (overlap === bestOverlap && dist < bestDist) ||
        (overlap === bestOverlap && dist === bestDist && mid > bestMid);
      if (better) { best = v; bestOverlap = overlap; bestDist = dist; bestMid = mid; }
    }
    if (best === null || (bestOverlap <= 0 && bestDist > 2)) return null;
    return best;
  }

  /* Prestige varyant seçimi: radio input + label metni.
     Radio value'su option_value.id olduğu için metinden eşleriz,
     input.click() temanın kendi değişim mantığını tetikler. */
  function applyVariantSelection(row) {
    var value = matchVariantValue(row);
    if (!value || !config.sizeOptionPosition) return false;
    var radios = document.querySelectorAll(
      'variant-picker input[type="radio"][data-option-position="' + config.sizeOptionPosition + '"]'
    );
    var norm = value.replace(/\s+/g, " ").trim().toLowerCase();
    for (var i = 0; i < radios.length; i++) {
      var input = radios[i];
      var label = input.closest("label") || document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
      var text = label ? label.textContent.replace(/\s+/g, " ").trim().toLowerCase() : "";
      if (text.indexOf(norm) !== -1) {
        input.click();
        return true;
      }
    }
    return false;
  }

  /* ---------------- sonuç ---------------- */
  function renderResult() {
    completed = true;
    overlay.querySelector("[data-fmk-eyebrow]").textContent = "BEDENİNİ BUL · SONUÇ";
    overlay.querySelector("[data-fmk-progress]").style.display = "none";

    var r = recommend(state.age, state.height, state.weight);
    var variantValue = matchVariantValue(r.row);
    var availability = (config && config.sizeAvailability) || {};
    var hasSizes = config && config.sizeValues && config.sizeValues.length > 0;

    var badge, copy;
    if (r.confidence === "out") {
      badge = { cls: "warn", label: "TABLO SINIRINDA" };
      copy = r.clamped === "over"
        ? "Boyu standart tablomuzun üstünde; en büyük bedenimizi öneriyoruz. Emin olamazsan bize yazabilirsin."
        : "Boyu standart tablomuzun altında; en küçük bedenimizi öneriyoruz. Emin olamazsan bize yazabilirsin.";
    } else if (r.bumped) {
      badge = { cls: "good", label: "RAHAT KALIP" };
      copy = "Boyuna göre " + r.heightRow.code + " çıkıyor; kilosu için bir üst bedeni önerdik, rahat etsin.";
    } else if (Math.abs(SIZES.indexOf(r.ageRow) - SIZES.indexOf(r.heightRow)) >= 2) {
      badge = { cls: "good", label: "BOYA GÖRE" };
      copy = "Beden seçiminde boy esastır; yaşı farklı gösterse de boyuna göre " + r.row.code + " öneriyoruz.";
    } else {
      badge = { cls: "good", label: "TAM İSABET" };
      copy = "Yaş, boy ve kilo aynı bedeni gösteriyor.";
    }

    var availNote = "";
    if (hasSizes && !variantValue) {
      availNote = "Bu üründe " + esc(r.row.code) + " bedenine denk gelen bir seçenek maalesef yok.";
    } else if (variantValue && Object.prototype.hasOwnProperty.call(availability, variantValue) && availability[variantValue] === false) {
      availNote = esc(variantValue) + " bedeni bu üründe şu an tükendi. Bedeni yine de seçebilirsin; stok gelince haber ver seçeneği çıkarsa kullanabilirsin.";
    }

    var headline = variantValue ? esc(variantValue) : esc(r.row.code);
    /* Alt satır, BÜYÜK gösterilen bedenin boy aralığını anlatmalı (eşleşen
       mağaza bedeni tablodaki farklı bir satıra denk gelebilir) */
    var displayRow = r.row;
    if (variantValue) {
      var vNorm = String(variantValue).replace(/\s+/g, " ").trim().toLowerCase();
      for (var di = 0; di < SIZES.length; di++) {
        if (SIZES[di].code.toLowerCase() === vNorm) { displayRow = SIZES[di]; break; }
      }
    }
    var subline;
    if (r.clamped === "over") subline = "EN BÜYÜK BEDENİMİZ · BOY " + esc(String(state.height)) + " CM";
    else if (r.clamped === "under") subline = "EN KÜÇÜK BEDENİMİZ · BOY " + esc(String(state.height)) + " CM";
    else subline = "BOY " + esc(String(displayRow.h[0])) + "-" + esc(String(displayRow.h[1])) + " CM İÇİN";

    clearResult();
    var wrap = document.createElement("div");
    wrap.className = "fmk-result";
    wrap.innerHTML =
      '<span class="fmk-badge fmk-reveal fmk-reveal-1 ' + badge.cls + '">' + badge.label + "</span>" +
      '<div class="fmk-size fmk-reveal fmk-reveal-2">' + headline + "</div>" +
      '<div class="fmk-range-label fmk-reveal fmk-reveal-2">' + subline + "</div>" +
      '<p class="fmk-copy fmk-reveal fmk-reveal-3">' + copy + "</p>" +
      (r.slim ? '<p class="fmk-note fmk-reveal fmk-reveal-3">İnce yapılı çocuklarda bel lastikli modeller daha iyi oturur.</p>' : "") +
      '<p class="fmk-note fmk-reveal fmk-reveal-3">Beden uymazsa 14 gün içinde kolayca iade edebilirsin.</p>' +
      (availNote ? '<p class="fmk-avail-note fmk-reveal fmk-reveal-3">' + availNote + "</p>" : "") +
      '<div class="fmk-breakdown fmk-reveal fmk-reveal-4">' +
      '<div class="fmk-breakdown__col"><span class="fmk-breakdown__key">YAŞ</span><span class="fmk-breakdown__size">' + esc(r.ageRow.code.replace(" Yaş", "")) + '</span><span class="fmk-breakdown__cm">' + state.age + " yaş</span></div>" +
      '<div class="fmk-breakdown__col"><span class="fmk-breakdown__key">BOY</span><span class="fmk-breakdown__size">' + esc(r.heightRow.code.replace(" Yaş", "")) + '</span><span class="fmk-breakdown__cm">' + state.height + " cm</span></div>" +
      '<div class="fmk-breakdown__col"><span class="fmk-breakdown__key">KİLO</span><span class="fmk-breakdown__size">' + (r.bumped ? "+1" : "=") + '</span><span class="fmk-breakdown__cm">' + state.weight + " kg</span></div>" +
      "</div>" +
      '<button type="button" class="fmk-restart fmk-reveal fmk-reveal-4" data-fmk-restart>Bilgileri baştan gir</button>';
    var sheet = overlay.querySelector(".fmk-sheet");
    sheet.insertBefore(wrap, overlay.querySelector("[data-fmk-controls]"));

    var controls = overlay.querySelector("[data-fmk-controls]");
    var ctaLabel = variantValue ? esc(variantValue) + " ile devam et" : esc(r.row.code) + " — Tamam";
    controls.innerHTML =
      '<div class="fmk-buttons"><button type="button" class="fmk-btn-next" data-fmk-continue>' + ctaLabel + "</button></div>";
    controls.querySelector("[data-fmk-continue]").addEventListener("click", function () {
      applyVariantSelection(r.row);
      closeQuiz();
    });
    wrap.querySelector("[data-fmk-restart]").addEventListener("click", function () {
      resetState();
      renderStep();
    });
  }

  /* ---------------- aç/kapat ---------------- */
  function openQuiz() {
    if (!config) {
      var cfgEl = document.querySelector("[data-fmk-config]");
      if (!cfgEl) return;
      try { config = JSON.parse(cfgEl.textContent); } catch (err) { return; }
    }
    if (!overlay) buildOverlay();
    if (!started || completed) { resetState(); started = true; }
    overlay.classList.add("is-open");
    document.documentElement.style.overflow = "hidden";
    renderStep();
  }

  function closeQuiz() {
    if (!overlay) return;
    overlay.classList.remove("is-open");
    document.documentElement.style.overflow = "";
  }

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest ? e.target.closest("[data-fmk-open]") : null;
    if (trigger) {
      e.preventDefault();
      openQuiz();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay && overlay.classList.contains("is-open")) closeQuiz();
  });
})();